define(function (require) {
	const Radio = require('backbone.radio');
	const dashboardChannel = Radio.channel('dashboardChannel');
	const ViewManager = require('civicsUtils/view_manager');
	const SavedSearchesTemplate = require('../saved_searches_template/t_cpv_saved_searches.hbs');
	const SavedSearchesChildView = require('../saved_searches_view/v_itv_saved_searches');
	const saved_searches_collection = require('civicsCollections/portal/saved_searches_collection');

	return Marionette.CompositeView.extend({
		template: SavedSearchesTemplate,
		tagName: 'div',
		childView: SavedSearchesChildView,
		childViewContainer: '.save-searches-list',
		childEvents: {
			'saveSearches:update': 'updateSavedSearchesList'
		},
		ui: {
			'expandCollapseButton' : '.saved-searches-collapse'
		},
		events: {
			'click @ui.expandCollapseButton': 'clickExpandCollapse'
		},
		initialize: function (options) {
			this.config = options.config;
			this.collection = options.collection;

			this.listenTo(dashboardChannel, 'saveSearches:update', this.updateSavedSearchesList);
            this.updateSavedSearchesList(); // Fetch saved searches initially
		},
		clickExpandCollapse: function() {

			$('.save-searches-list .collapsible-content').each(function(index) {
				if($(this).hasClass('expanded')) {
					$(this).removeClass('expanded');
					$(this).addClass('collapsed');
					$(this).hide();
				} else {
					$(this).addClass('expanded');
					$(this).removeClass('collapsed');
					$(this).show();
				}
			})

		},
		onDestroy: function() {
			this.stopListening(dashboardChannel); // Stop listening to avoid further updates after the view is destroyed
		},
		onRender: function() {
			this.$el.rhythmCivicsTooltipInit();
			this.$el.rhythmThemeInit();
		},
		updateSavedSearchesList: function () {
			const source = window.location.hash?.toLowerCase().includes('task')
							? 'inspections'
							: this.config.filterName?.toLowerCase() === 'mytaskcard'
								? 'inspections'
								: 'projects';

			if (!this.isDestroyed) {
				const sortedModels = this.collection.sortBy((model) =>
					model.get('isDefault') ? -1 : 1
				);
				this.collection.reset(sortedModels); // Reset with sorted models
				this.render();
				return this.collection;
			}
		},
		templateHelpers: function() {
			return {
				noSavedSearch: !this.collection.length > 0,
				isMyTaskDashboard: this.config.filterType == 'tasks'
			};
		},
	});
});
